/* created by CoolGuy on 2018/12/13 */
const request = require('../utils/request.js');
const commonApi = require('./common');

const redpack = {
    gettime: commonApi.gettime,
    sendsms: commonApi.sendsms,
    bindphone: ({ phone, galleryid, content, code, nickname}) => {
        return new Promise((resolve, reject) => {
            if(!galleryid){
                reject();
                console.error('gallery id is null!');
                return;
            }
            request({
                url: '/api/wxuser/bindphone',
                method: 'post',
                data: { phone, galleryid, content, code, nickname}
            }).then(jsonData => {
                resolve(jsonData);
            }).catch(reject);
        })
    },
    getdetail: (galleryid) => {
        return new Promise((resolve, reject) => {
            if(!galleryid){
                reject();
                console.error('gallery id is null in getdetail');
                return;
            }
            request({
                url:'/api/redpackage/list',
                method: 'get',
                data: {galleryid}
            }).then(jsonData => {
                resolve(jsonData);
            }).catch(reject);
        })
    },
    getredpack:(id) => {
        return new Promise( (resolve,reject) => {
            request({
                url:'/api/redpackage/get',
                method: 'post',
                data:{id}
            }).then(jsonData=>{
                resolve(jsonData)
            }).catch(reject);
        })
    },
    askredpack:(id) => new Promise( (resolve ,reject)=> {
        request({
            url: '/api/redpackage/ask',
            method: 'post',
            data: {id}
        }).then(jsonData=>{
            resolve(jsonData)
        }).catch(reject);
    }),
    getredpackdetail:(id ,page = 1)=> new Promise( (resolve,reject) => {
        request({
            url: '/api/redpackage/detail',
            method: 'get',
            data: {id,page}
        }).then(jsonData=>{
            resolve(jsonData)
        }).catch(reject);
    }),
    precreate: ({amount, galleryid})=> new Promise( (resolve ,reject)=> {
        request({
            url: '/api/redpackage/precreate',
            method: 'post',
            data: {amount, galleryid}
        }).then(jsonData=>{
            resolve(jsonData)
        }).catch(reject);
    }),
    create: ({ number=1, amount=0, type='normal', content, tradeid, galleryid})=> new Promise( (resolve ,reject)=> {
        request({
            url: '/api/redpackage/create',
            method: 'post',
            data: { number, amount, type, content, tradeid, galleryid}
        }).then(jsonData=>{
            resolve(jsonData)
        }).catch(reject);
    }),

}

module.exports = redpack;



// WEBPACK FOOTER //
// ./src/actions/redpack.js